// extracted by mini-css-extract-plugin
module.exports = {"upload-list-images__wrapper":"upload-list-images_upload-list-images__wrapper__gAQ50","upload-list-images__placeholder":"upload-list-images_upload-list-images__placeholder__yr66W"};